import React, { Component } from 'react';
import moment from 'moment-timezone';
import { MEDIUM } from './AssistantContainer.js';
import { translate } from 'react-i18next';

class Notifications extends Component {
  
  renderDelivery = (delivery, index) => {
    const date = moment(delivery.date, 'YYYY-MM-DD HH:mm:ss');
    return(
      <li className="timeline-inverted" key={index}>
        <div className="timeline-badge danger">
          <i className="fa fa-truck" />
        </div>
        <div className="timeline-panel">
          <div className="timeline-heading">
            <h4 className="timeline-title">{"Envío de " + delivery.sender}</h4>
            <p>
              <small className="text-muted">
                <i className="fa fa-clock-o" />&nbsp;
                {date.format('dddd, LLL')}
              </small>
            </p>
          </div>
          <div className="timeline-body">
            <p>
              {delivery.comments}
            </p>
            <p>
              <strong>{delivery.company + ": " + delivery.tracking}</strong>
            </p>
          </div>
        </div>
      </li>
    );
  }

  renderMessage = (message, index) => {
    const date = moment(message.date, 'YYYY-MM-DD HH:mm:ss');
    let badge, icon, title;
    switch (message.medium) {
      default:
      case MEDIUM.CALL:
        badge = "timeline-badge info";
        icon = "fa fa-phone";
        title = "Llamada de";
        break;
      case MEDIUM.VISIT:
        badge = "timeline-badge warning";
        icon = "fa fa-user";
        title = "Visita de";
        break;
    }

    return(
      <li key={index}>
        <div className={badge}>
          <i className={icon} />
        </div>
        <div className="timeline-panel">
          <div className="timeline-heading">
            <h4 className="timeline-title">
              {title + " " + message.sender + (message.reference ? " de " + message.reference : "")}
            </h4>
            <p>
              <small className="text-muted">
                <i className="fa fa-clock-o" />&nbsp;
                {date.format('dddd, LLL')}
              </small>
            </p>
          </div>
          <div className="timeline-body">
            <p>
              {message.message}
            </p>
            <hr />
            <span className={message.phone ? "" : "hidden"}>
              <a
                className="btn btn-primary"
                href={"tel:" + message.phone}>
                <i className="fa fa-phone" />&nbsp;
                {message.phone}
              </a>&nbsp;
            </span>
            <span className={message.email ? "" : "hidden"}>
              <a
                className="btn btn-primary btn-outline"
                href={"mailto:" + message.email}>
                <i className="fa fa-envelope" />&nbsp;
                Enviar e-mail
              </a>
            </span>
          </div>
        </div>
      </li>
    );
  }

  render() {
    const { t } = this.props;
    return(
      <div>
        <div className="hidden-xs">
          <div className="jumbotron">
            <div className="row text-center">
              <div className="col-sm-6">
                <p>{t('dashboard.assistant.heading_messages')}</p>
              </div>
              <div className="col-sm-6">
                <p>{t('dashboard.assistant.heading_deliveries')}</p>
              </div>
            </div>
          </div>
        </div>
        <ul className="timeline">
          {this.props.notifications.map((notification, index) => notification.message
            ? this.renderMessage(notification, index)
            : this.renderDelivery(notification, index))}
        </ul>
      </div>
    );
  }
}

export default translate('common')(Notifications);



// WEBPACK FOOTER //
// ./src/dashboard/assistant/Notifications.js